module.exports = __webpack_public_path__ + "static/media/yuemeishanadj.1dd2c100.webp";